import { render, staticRenderFns } from "./ScheduleBadge.vue?vue&type=template&id=5b1bcaea&scoped=true"
import script from "./ScheduleBadge.vue?vue&type=script&lang=js"
export * from "./ScheduleBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1bcaea",
  null
  
)

export default component.exports